// library imports
import { useState, useEffect, useContext } from "react";
import { Empty, Skeleton, Flex } from "antd";
// hook imports
import useFetch from "../../hooks/useFetch";
// context imports
import { IndexContext } from "../../context/IndexContext";
// component imports
import CustomBarChart from "../common/CustomBarChart";
// config imports
import { MQTT_REFRESH_RATE } from "../../configs/configs";

export default function SunHourContent({
  parentContainerHeight,
  dateSelected,
  dateType,
}) {
  const [fetchWrapper] = useFetch();
  const { siteSelected, notificationApi } = useContext(IndexContext);

  // loading state
  const [loading, setLoading] = useState(true);

  // sun hour data
  const [sunHourData, setSunHourData] = useState([]);
  const [avgSunHour, setAvgSunHour] = useState("-");

  // chart date
  const [chartDate, setChartDate] = useState("");

  /** API to get the sun hour data */
  function getSunHourData() {
    fetchWrapper({
      endpoint_url: "dashboard/getSunHourData",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        date_selected: dateSelected
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss"),
        date_type: dateType,
      },

      onSuccess: (response) => {
        setSunHourData(response.data.graph_data);
        setAvgSunHour(response.data.avg_sun_hour);
        setChartDate(response.data.chart_date);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to get sun hour data.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    setLoading(true);
    if (siteSelected && dateSelected && dateType) {
      getSunHourData();

      const timer = setInterval(() => {
        getSunHourData();
      }, MQTT_REFRESH_RATE * 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [siteSelected, dateSelected, dateType]);

  return (
    <div className="h-100 w-100">
      <div
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          paddingLeft: "12px",
        }}
      >
        Sun Hour {loading ? "" : `(${chartDate})`}
      </div>
      {loading === false ? (
        sunHourData.length === 0 ? (
          <Flex
            vertical
            justify="center"
            align="center"
            style={{
              height: `calc(${parentContainerHeight}px - 24px - 26px)`,
            }}
          >
            <Empty />
          </Flex>
        ) : (
          <div className="h-100">
            <div
              style={{
                paddingLeft: "12px",
                paddingTop: "8px",
              }}
            >
              <span>Average:&nbsp;</span>
              <span style={{ fontWeight: "bold" }}>
                {avgSunHour !== "-" ? avgSunHour.toFixed(2) + "h" : avgSunHour}
              </span>
            </div>
            <CustomBarChart
              data={sunHourData.map((item) => {
                const newItem = { ...item };
                for (const key in newItem) {
                  if (newItem[key] === "-") {
                    newItem[key] = null;
                  }
                }
                return newItem;
              })}
              xAxis="date"
              yAxis="value"
              xAxisTitle="Date"
              yAxisTitle="Sun Hour (h)"
              height={parentContainerHeight - 24 - 26 - 30} // carousel card height - card body padding - title height - statistic data height
            />
          </div>
        )
      ) : (
        <Skeleton
          active={true}
          style={{
            padding: "1rem",
            maxWidth: "70%",
            margin: "auto",
          }}
          paragraph={{ rows: 5 }}
        />
      )}
    </div>
  );
}
